export default __webpack_public_path__ + "static/media/3034.35c4aa84.png";